<template>
  <div class="auth-layout-wrap">
    <div class="auth-content">
      <div class="card o-hidden">
        <div class="row">
          <div class="col-md-6">
            <div class="p-4">
              <div class="auth-logo text-center mb-4">
                <img src="logo.png" alt="" style="width:200px; height: auto;">
              </div>
              <h1 class="mb-3 text-18">{{$t('login.giris')}}</h1>
              <el-form v-loading="loading" :model="LoginForm" status-icon ref="LoginForm">
                <div class="form-group">

                  <el-form-item
                    prop="Kemail"
                    label="Email"
                    autocomplete="off"
                    :rules="[
                      { required: true, message: $t('login.email.requred') },
                      { type: 'email', message: $t('login.email.hata') }
                    ]">
                    <el-input v-model="LoginForm.Kemail"></el-input>
                  </el-form-item>

                </div>
                <div class="form-group">

                  <el-form-item
                    prop="Kpass"
                    :label="$t('login.sifre')"
                    autocomplete="off"
                    :rules="[{ required: true, message: $t('login.sifrerequred') }]">
                    <el-input type="password" v-model="LoginForm.Kpass"></el-input>
                  </el-form-item>

                </div>
                <button class="btn btn-rounded btn-primary btn-block mt-2" type="button" @click="onSubmit('LoginForm')">
                  {{$t('login.girisbutton')}}
                </button>

              </el-form>

              <div class="mt-3 text-center">

                <router-link to="/giris/parola" class="text-muted">
                  <u>{{$t('login.sifreunuttum')}}</u>
                </router-link>

                <br>
                <router-link to="/giris/kayit" class="text-muted">
                  <u>{{$t('login.kayit')}}</u>
                </router-link>

              </div>
            </div>
          </div>
          <div class="col-md-6 text-center yan"></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                LoginForm: {
                    Kemail: 'mestav@mestav.com',
                    Kpass: '1',
                }
            };
        },
        methods: {
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.$store.dispatch("login", {...this.LoginForm, mode: 'giris'})
                            .then(response => {
                                console.log(response);
                                if (response.Status == "OK") {
                                    this.loading = false;
                                    this.$router.push("/panel");
                                } else {
                                    this.loading = false;
                                    if (response.Hata.Kemail && response.Hata.Kpass) {
                                        this.$message.error(response.Hata.Kemail);
                                    }

                                    if (response.Hata.Kemail && response.Hata.Kpass == '') {
                                        this.$message.error(response.Hata.Kemail);
                                    }

                                    if (response.Hata.Kemail == '' && response.Hata.Kpass) {
                                        this.$message.error(response.Hata.Kemail);
                                    }
                                }
                            })

                    }
                });


            }
        }
    }
</script>
<style>
  .auth-layout-wrap {
    background-image: url('../../assets/images/photo-wide-4.jpg')
  }

  .yan {
    background-size: cover;
    background-image: url('../../assets/images/photo-long-3.jpg')
  }
</style>



// WEBPACK FOOTER //
// src/Module/giris/index.vue